import { Button } from "@mui/material";

export default Button;
